/**
 * The registration tariff, in minor units.
 *
 * MIRRORS `ondo.registration_tariff()` BY NAME, and rls.sh asserts the two
 * agree — see 20260910110000_registration_fees.sql, decision 4. The SQL is
 * the record: the fee row a sale owes is written by trigger from that function
 * and never from here. This copy exists so the Sell wizard can PREVIEW the fee
 * before the sale, on the step that has told directors "$150 · plain" and
 * "$350 · covenant" since it shipped, without a round trip for two numbers.
 *
 * A third copy anywhere is a drift waiting to happen. `SELL_COPY.fee` used to
 * be one; it reads from here now.
 */
export const REGISTRATION_FEE_MINOR = {
    plain: 15_000,
    premium: 35_000,
};
export const REGISTRATION_FEE_CURRENCY = "USD";
//# sourceMappingURL=registrationFee.js.map